import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";

const REQUIRED_ENV_VARS = [
    "CANVAS_PORTAL_NR_APPLICATION_ID",
    "CANVAS_PORTAL_NR_LICENSE_KEY",
    "CANVAS_PORTAL_NR_ACCOUNT_ID",
    "CANVAS_PORTAL_AGENT_ID",
    "CANVAS_PORTAL_NR_TRUST_KEY",
] as const;

const getBuildTimeEnv = () => ({
    CANVAS_PORTAL_NR_APPLICATION_ID: process.env.CANVAS_PORTAL_NR_APPLICATION_ID,
    CANVAS_PORTAL_NR_LICENSE_KEY: process.env.CANVAS_PORTAL_NR_LICENSE_KEY,
    CANVAS_PORTAL_NR_ACCOUNT_ID: process.env.CANVAS_PORTAL_NR_ACCOUNT_ID,
    CANVAS_PORTAL_AGENT_ID: process.env.CANVAS_PORTAL_AGENT_ID,
    CANVAS_PORTAL_NR_TRUST_KEY: process.env.CANVAS_PORTAL_NR_TRUST_KEY,
});

export const isNewRelicEnabled = (): boolean => {
    const env = getBuildTimeEnv();

    return REQUIRED_ENV_VARS.every((key) => Boolean(env[key]?.trim()));
};

let browserAgent: BrowserAgent | null = null;

export const initNewRelic = (): BrowserAgent | null => {
    if (browserAgent) {
        return browserAgent;
    }

    if (!isNewRelicEnabled()) {
        return null;
    }

    const env = getBuildTimeEnv();
    const applicationId = env.CANVAS_PORTAL_NR_APPLICATION_ID as string;
    const licenseKey = env.CANVAS_PORTAL_NR_LICENSE_KEY as string;
    const accountId = Number(env.CANVAS_PORTAL_NR_ACCOUNT_ID);
    const agentId = Number(env.CANVAS_PORTAL_AGENT_ID);
    const trustKey = Number(env.CANVAS_PORTAL_NR_TRUST_KEY);
    const numericFields = { accountId, agentId, trustKey, applicationId: Number(applicationId) };

    if (!Object.values(numericFields).every((value) => Number.isFinite(value))) {
        return null;
    }

    try {
        browserAgent = new BrowserAgent({
            info: {
                applicationID: applicationId,
                beacon: "bam.nr-data.net",
                errorBeacon: "bam.nr-data.net",
                licenseKey,
                sa: 1,
            },
            init: {
                ajax: {
                    deny_list: ["bam.nr-data.net"],
                },
                browser_consent_mode: {
                    enabled: false,
                },
                distributed_tracing: {
                    enabled: true,
                },
                performance: {
                    capture_detail: false,
                    capture_marks: false,
                    capture_measures: true,
                },
                privacy: {
                    cookies_enabled: true,
                },
            },
            loader_config: {
                accountID: accountId,
                agentID: agentId,
                applicationID: Number(applicationId),
                licenseKey,
                trustKey,
            },
        });
} catch (error) {
    console.error("Failed to initialize New Relic BrowserAgent", error);
    browserAgent = null;
}

    return browserAgent;
};

export const setNewRelicRouteName = (routeName: string): void => {
    window.newrelic?.setCurrentRouteName?.(routeName);
};
